import React from "react";

function IconBed(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.429 4.408a.9.9 0 0 0-.896-.808h-14.4a.9.9 0 0 0-.9.9v7.517a2.7 2.7 0 0 0-2.4 2.683v4.2a.9.9 0 0 0 .9.9h1.2v1.8a.9.9 0 0 0 1.8 0v-1.8h13.2v1.8a.9.9 0 0 0 1.8 0v-1.8h1.2a.9.9 0 0 0 .9-.9v-4.2a2.7 2.7 0 0 0-2.4-2.683V4.5a.903.903 0 0 0-.004-.092Zm-1.796.992h-12.6v5.138c.096-.025.197-.038.3-.038h3a1.8 1.8 0 0 1 1.775 1.5h2.45a1.8 1.8 0 0 1 1.775-1.5h3a1.2 1.2 0 0 1 .3.038V5.4Zm-14.1 8.4h15.6a.9.9 0 0 1 .9.9V18h-17.4v-3.3a.9.9 0 0 1 .9-.9Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconBed;
